export default "__VITE_ASSET__rqr1JWgw__"